import { Button, FlexContainer, TYPOGRAPHY, Title } from '@emarketer/componentlibrary';
import { COLOR } from '../../../theme/constants';
import styled from 'styled-components';

export const PillTooltipContainer = styled(FlexContainer)<{ active: boolean }>`
  border-radius: 5px;
  border: 1px solid ${COLOR.BLACK};
  background-color: ${(p) => (p.active ? COLOR.BLACK : 'transparent')};
  color: ${(p) => (p.active ? COLOR.WHITE : COLOR.BLACK)};
  padding: 6px 14px;
`;

export const PillTooltipWrapper = styled.div``;

export const PillTooltipContainerTrigger = styled(Button)``;

export const PillTooltipLabel = styled(Title)`
  font-size: 16px;
  ${TYPOGRAPHY.BLACK};
`;

export const PillTooltipCounter = styled.div`
  // TODO when needed
`;
